export enum CommissionModel {
  FlatFee = 1,
  OnePercent = 2,
  Less125k = 3,
  Less75k = 4,
  BuyerNoCashBack = 5,
  Traditional = 6,
  Buyer1kRebate = 7,
  Buyer1Percent = 8,
  BuyerTiered = 9,
  CleverCashBackHalfPercent = 10,
  CleverCashBack250 = 11,
  OneAndHalfPercent = 12,
  BuyerModelNew = 13,
  MrCooper = 14,
  MrCooperBuyer = 15,
  MrCooperSeller = 16,
  GravyBuyer = 17,
  ESuiteRewardsBuyer = 18,
  ESuiteRewardsSeller = 19,
  USBankBuyer = 20,
  USBankSeller = 21,
  MrCooperBuyerLenderCreditHalfPercentModel = 22,
  MrCooperSellerCCBHalfPercentModel = 23,
  Freedom2Percent = 24,
  FreedomCCB1k = 25,
  PHHBuyer = 26,
  OnityBuyerFullCommissionNoCCB = 27,
  OnityBuyerFullCommissionCCBHalfPercent = 28,
  NavyFederalBuyer = 29,
  NavyFederalSeller = 30,
  OnitySellerFullCommissionNoCCB = 31,
  OnitySellerFullCommissionCCBHalfPercent = 32,
  SimpliBorrowBuyerFullCommissionNoCCB = 33,
  SimpliBorrowBuyerFullCommissionCCBHalfPercent = 34,
  SimpliBorrowSellerFullCommissionNoCCB = 35,
  SimpliBorrowSellerFullCommissionCCBHalfPercent = 36,
  BetterLenderCredit = 60,
  BetterSellerIncentive1k = 61,
  TwoPercent = 63,
}

export const commissionModelLabelById = {
  [CommissionModel.FlatFee]: 'Flat Fee Model',
  [CommissionModel.OnePercent]: '1% Model',
  [CommissionModel.Less125k]: '<125k Model',
  [CommissionModel.Less75k]: '<75k Model',
  [CommissionModel.BuyerNoCashBack]: 'Buyer No Clever Cash Back',
  [CommissionModel.Traditional]: 'Traditional Model',
  [CommissionModel.Buyer1kRebate]: 'Buyer $1K Rebate Model',
  [CommissionModel.Buyer1Percent]: 'Buyer 1% Rebate Model',
  [CommissionModel.BuyerTiered]: 'Buyer Tiered Rebate Model',
  [CommissionModel.CleverCashBackHalfPercent]: 'Clever Cash Back (0.5%)',
  [CommissionModel.CleverCashBack250]: 'Clever Cash Back ($250)',
  [CommissionModel.OneAndHalfPercent]: '1.5% Model',
  [CommissionModel.BuyerModelNew]: 'Buyer Model (new $250)',
  [CommissionModel.MrCooper]: 'Mr Cooper CCB',
  [CommissionModel.MrCooperBuyer]: 'Mr Cooper Buyer CCB',
  [CommissionModel.MrCooperSeller]: 'Mr Cooper Seller CCB',
  [CommissionModel.GravyBuyer]: 'Gravy Buyer',
  [CommissionModel.ESuiteRewardsSeller]: 'Rewards Seller',
  [CommissionModel.ESuiteRewardsBuyer]: 'Rewards Buyer',
  [CommissionModel.USBankBuyer]: 'U.S. Bank Buyer',
  [CommissionModel.USBankSeller]: 'U.S. Bank Seller',
  [CommissionModel.MrCooperBuyerLenderCreditHalfPercentModel]:
    'Mr Cooper Lender Credit (0.5%)',
  [CommissionModel.MrCooperSellerCCBHalfPercentModel]: 'Mr Cooper CCB (0.5%)',
  [CommissionModel.Freedom2Percent]: 'Freedom 2% Model',
  [CommissionModel.FreedomCCB1k]: 'Freedom CCB ($1K)',
  [CommissionModel.PHHBuyer]: 'PHH Buyer CCB',
  [CommissionModel.OnityBuyerFullCommissionNoCCB]:
    'Onity Buyer Full Commission (No CCB)',
  [CommissionModel.OnityBuyerFullCommissionCCBHalfPercent]:
    'Onity Buyer Full Commission (CCB 0.5%)',
  [CommissionModel.NavyFederalBuyer]: 'Navy Federal Buyer',
  [CommissionModel.NavyFederalSeller]: 'Navy Federal Seller',
  [CommissionModel.OnitySellerFullCommissionNoCCB]:
    'Onity Seller Full Commission (No CCB)',
  [CommissionModel.OnitySellerFullCommissionCCBHalfPercent]:
    'Onity Seller Full Commission (CCB 0.5%)',
  [CommissionModel.SimpliBorrowBuyerFullCommissionNoCCB]:
    'SimpliBorrow Buyer No CCB - Full Commission',
  [CommissionModel.SimpliBorrowBuyerFullCommissionCCBHalfPercent]:
    'SimpliBorrow Buyer CCB 0.5% - Full Commission',
  [CommissionModel.SimpliBorrowSellerFullCommissionNoCCB]:
    'SimpliBorrow Seller No CCB - Full Commission',
  [CommissionModel.SimpliBorrowSellerFullCommissionCCBHalfPercent]:
    'SimpliBorrow Seller CCB 0.5% - Full Commission',
  [CommissionModel.BetterLenderCredit]: 'Better Lender Credit',
  [CommissionModel.BetterSellerIncentive1k]: 'Better Seller Incentive $1k',
  [CommissionModel.TwoPercent]: '2% Model',
};

export const commissionModels = Object.entries(commissionModelLabelById).map(
  ([key, label]) => ({
    label,
    value: Number(key) as CommissionModel,
  }),
);

export const buyerModels = <const>[
  {
    label: 'Buyer No Clever Cash Back',
    value: CommissionModel.BuyerNoCashBack,
  },
  { label: 'Buyer $1K Rebate Model', value: CommissionModel.Buyer1kRebate },
  { label: 'Buyer 1% Rebate Model', value: CommissionModel.Buyer1Percent },
  { label: 'Buyer Tiered Rebate Model', value: CommissionModel.BuyerTiered },
  {
    label: 'Clever Cash Back (0.5%)',
    value: CommissionModel.CleverCashBackHalfPercent,
  },
  {
    label: 'Clever Cash Back ($250)',
    value: CommissionModel.CleverCashBack250,
  },
  { label: 'Buyer Model (new $250)', value: CommissionModel.BuyerModelNew },
  { label: 'Mr Cooper CCB', value: CommissionModel.MrCooper },
  { label: 'Mr Cooper Buyer CCB', value: CommissionModel.MrCooperBuyer },
  { label: 'Gravy Buyer', value: CommissionModel.GravyBuyer },
  { label: 'Rewards Buyer', value: CommissionModel.ESuiteRewardsBuyer },
  { label: 'U.S. Bank Buyer', value: CommissionModel.USBankBuyer },
  {
    label: 'Mr Cooper Lender Credit (0.5%)',
    value: CommissionModel.MrCooperBuyerLenderCreditHalfPercentModel,
  },
  { label: 'Freedom CCB ($1K)', value: CommissionModel.FreedomCCB1k },
  { label: 'PHH Buyer CCB', value: CommissionModel.PHHBuyer },
  {
    label: 'Onity Buyer Full Commission (No CCB)',
    value: CommissionModel.OnityBuyerFullCommissionNoCCB,
  },
  {
    label: 'Onity Buyer Full Commission (CCB 0.5%)',
    value: CommissionModel.OnityBuyerFullCommissionCCBHalfPercent,
  },
  { label: 'Navy Federal Buyer', value: CommissionModel.NavyFederalBuyer },
  {
    label: 'SimpliBorrow Buyer No CCB - Full Commission',
    value: CommissionModel.SimpliBorrowBuyerFullCommissionNoCCB,
  },
  {
    label: 'SimpliBorrow Buyer CCB 0.5% - Full Commission',
    value: CommissionModel.SimpliBorrowBuyerFullCommissionCCBHalfPercent,
  },
  { label: 'Better Lender Credit', value: CommissionModel.BetterLenderCredit },
];

export const sellerModels = <const>[
  { label: 'Flat Fee Model', value: CommissionModel.FlatFee },
  { label: '1% Model', value: CommissionModel.OnePercent },
  { label: '<125k Model', value: CommissionModel.Less125k },
  { label: '<75k Model', value: CommissionModel.Less75k },
  { label: 'Traditional Model', value: CommissionModel.Traditional },
  { label: '1.5% Model', value: CommissionModel.OneAndHalfPercent },
  { label: '2% Model', value: CommissionModel.TwoPercent },
  { label: 'Mr Cooper Seller CCB', value: CommissionModel.MrCooperSeller },
  { label: 'Rewards Seller', value: CommissionModel.ESuiteRewardsSeller },
  { label: 'U.S. Bank Seller', value: CommissionModel.USBankSeller },
  {
    label: 'Mr Cooper CCB (0.5%)',
    value: CommissionModel.MrCooperSellerCCBHalfPercentModel,
  },
  { label: 'Freedom 2% Model', value: CommissionModel.Freedom2Percent },
  { label: 'Navy Federal Seller', value: CommissionModel.NavyFederalSeller },
  {
    label: 'Onity Seller Full Commission (No CCB)',
    value: CommissionModel.OnitySellerFullCommissionNoCCB,
  },
  {
    label: 'Onity Seller Full Commission (CCB 0.5%)',
    value: CommissionModel.OnitySellerFullCommissionCCBHalfPercent,
  },
  {
    label: 'SimpliBorrow Seller No CCB - Full Commission',
    value: CommissionModel.SimpliBorrowSellerFullCommissionNoCCB,
  },
  {
    label: 'SimpliBorrow Seller CCB 0.5% - Full Commission',
    value: CommissionModel.SimpliBorrowSellerFullCommissionCCBHalfPercent,
  },
  {
    label: 'Better Seller Incentive $1k',
    value: CommissionModel.BetterSellerIncentive1k,
  },
];

export const commissionModelDefaultTemplateHashmap = <const>{
  'Flat Fee Model': 'commission_model_seller_3k',
  '1% Model': 'commission_model_seller_1%',
  '<125k Model': 'commission_model_seller_traditional',
  '<75k Model': 'commission_model_seller_traditional',
  'Buyer No Clever Cash Back': '',
  'Traditional Model': '',
  'Buyer $1K Rebate Model': 'commission_model_buyer_1k',
  'Buyer 1% Rebate Model': 'commission_model_buyer_1%',
  'Buyer Tiered Rebate Model': '',
  'Clever Cash Back ($250)': 'commission_model_ccb_250',
  'Clever Cash Back (0.5%)': 'commission_model_ccb_0.5',
  '1.5% Model': 'commission_model_seller_1.5%',
  'Buyer Model (new $250)': 'commission_model_new_buyer_model',
};
